import { Ray } from "@babylonjs/core/Culling/ray";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import type { AbstractMesh } from "@babylonjs/core/Meshes/abstractMesh";
import type { Scene } from "@babylonjs/core/scene";

const OCCLUDING_SURFACES = new Set(["wall", "door", "computer", "tank", "crate"]);
const OCCLUSION_RAY = new Ray(Vector3.Zero(), Vector3.Forward(), 0);

export function hasWorldLineOfSight(scene: Scene, start: Vector3, end: Vector3): boolean {
  const offsetX = end.x - start.x;
  const offsetY = end.y - start.y;
  const offsetZ = end.z - start.z;
  const distance = Math.hypot(offsetX, offsetY, offsetZ);
  if (distance <= 0.001) return true;

  OCCLUSION_RAY.origin.copyFrom(start);
  OCCLUSION_RAY.direction.set(offsetX / distance, offsetY / distance, offsetZ / distance);
  OCCLUSION_RAY.length = distance;
  const obstruction = scene.pickWithRay(OCCLUSION_RAY, isOccludingMesh, true);
  return !obstruction?.hit;
}

function isOccludingMesh(mesh: AbstractMesh): boolean {
  const surface = (mesh.metadata as { surface?: string } | null)?.surface;
  return mesh.isEnabled() && surface !== undefined && OCCLUDING_SURFACES.has(surface);
}
